
import './DHome.scss'
import { ActivityInfoModel, QuestionnaireModel } from '@/models/typing'
import { useRecoilRefresher_UNSTABLE, useRecoilState, useRecoilValue, useRecoilValueLoadable } from 'recoil'
import { fetchActivityInfoState, quizState } from '@/models/quizState'
import { activityInfoState } from '@/App'
import ErrorPage from '@/components/Error'
import { DefaultLoadingPage } from '@/components/Loading'
import { useEffect } from 'react'
import { HomePageItemComponent } from '../Mobile/MHome'
import { LayoutDesktop } from '@/components/LayoutPC/LayoutDesktop'
import { QuizAlert } from '@/components/Alert'


type HomePageProps = {
    list: QuestionnaireModel[]
}


const HomePage = ({ list }: HomePageProps) => {

    const quiz = useRecoilValue(quizState)

    return (
        <LayoutDesktop>
            <div className='desktop-content-view'>
                <div className='home-title'> </div>
                <div className='home-content'>
                {
                    list.map((item, index) => (
                        (
                            <HomePageItemComponent item={item} key={index} />
                        )
                    ))
                }
                </div>
                <div className='home-bottom'></div>
                {quiz.alert && <QuizAlert />}
            </div>
        </LayoutDesktop>
    )

}


export const DesktopHome = () => {

    const [activityInfo, setActivityInfo] = useRecoilState(activityInfoState)

    const { state, contents } = useRecoilValueLoadable<ActivityInfoModel>(fetchActivityInfoState)

    const refresh = useRecoilRefresher_UNSTABLE(fetchActivityInfoState)


    useEffect(() => {
        if (state === 'hasValue') {
            setActivityInfo(contents)
        }
    }, [state,contents,setActivityInfo])

    switch (state) {
        case 'hasValue':
            return <HomePage list={activityInfo.questionnaire_list} />
        case 'hasError':
            return <ErrorPage message={contents.message} onRetry={() => { refresh() }} />; 
        case 'loading':
            return <DefaultLoadingPage />;
    }

}
